import styled from 'styled-components';

export const DEFAULT_SIZE = 180;

export const ProfilePictureContainer = styled.div<{
    $size?: number;
    $hideUpload: boolean;
}>`
    .ant-upload-list-picture-card-container {
        width: ${({ $size = DEFAULT_SIZE }) => $size}px;
        height: ${({ $size = DEFAULT_SIZE }) => $size}px;
        display: grid;
        place-items: center;
    }

    .ant-upload.ant-upload-select {
        width: ${({ $size = DEFAULT_SIZE }) => $size}px;
        height: ${({ $size = DEFAULT_SIZE }) => $size}px;
    }

    ${({ $hideUpload }) =>
        $hideUpload &&
        `
      .ant-upload.ant-upload-select {
        display: none !important;
      }
    `}
`;
